
  export default {
    name: `AeqSeparator`,
    props: {},
    data() {
      return {}
    }
  }
